import script from "./MenuListModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuListModal.vue?vue&type=script&setup=true&lang=js"

import "./MenuListModal.vue?vue&type=style&index=0&id=fc886910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc886910"]])

export default __exports__